import CompletedRequests from '@/components/Requests/CompletedRequests';
import PendingRequests from '@/components/Requests/PendingRequests';
import Header from '@/components/UI/Header';
import { Panel, Tab, Tabs } from '@/components/UI/Tabs';

const Requests = () => {
  return (
    <>
      <div className="ph4 pb3">
        <Header mainHeaderText="Requests" />
      </div>
      <Tabs>
        <div className="bb b--moon-gray mh3 mh4-l">
          <Tab className="f4">Pending</Tab>
          <Tab className="f4">Completed</Tab>
        </div>
        <div className="ph4 pt4">
          <Panel>
            <PendingRequests />
          </Panel>
          <Panel>
            <CompletedRequests />
          </Panel>
        </div>
      </Tabs>
    </>
  );
};

export default Requests;
